import React, { PropTypes } from 'react';
import StreamEditForm from '../StreamEditForm';
import LoadingSpinner from '../../../LoadingSpinner';

class PromotionNew extends React.Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.props.fetch();
  }

  render() {
    let { loading, rest } = this.props;

    return (
      <LoadingSpinner show={loading}>
        <StreamEditForm label="Create Stream" {...rest}/>
      </LoadingSpinner>
    );
  }
}

export default PromotionNew;



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamNew/StreamNew.jsx